import { Box, Center, Flex, Image, Spinner, Stack, Text, useToast, VStack } from '@chakra-ui/react';
import axios from 'axios';
import { useEffect, useState } from 'react';
import { RiThumbDownFill, RiThumbUpFill } from 'react-icons/ri';
import { useParams } from 'react-router-dom';

import caminhoesparalelos from '../assets/img/caminhoesparalelos.png';

function AtualizaCadastroOnsupply(): JSX.Element {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { guid } = useParams();
  const toast = useToast();

  useEffect(() => {
    async function PostUpdateTransp() {
      setLoading(true);
      try {
        await axios.post(`${process.env.REACT_APP_OS_URL}/Empresa/Filial/AtualizarEmpresaFilial/Temporario/${guid}`);
      } catch {
        setError(true);
      } finally {
        setLoading(false);
      }
    }
    PostUpdateTransp();
  }, [guid, toast]);

  return (
    <Stack w="100%" h="100%" spacing={0} direction={{ base: 'column', lg: 'row' }}>
      <VStack w={{ base: '100%', lg: '720px' }} h="100%" spacing={0}>
        <Center flexDir="column" h="100%" mt={2} justifyContent="center" pb={4}>
          {loading ? (
            <>
              <Text as="h1" mt="4" color="brand.500" fontSize={{ base: 'xl', lg: '3xl' }} fontWeight="bold" textAlign="center" lineHeight="28px">
                Confirmando...
              </Text>
              <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="brand.500" size="xl" />
            </>
          ) : (
            <>
              {error ? (
                <>
                  <RiThumbDownFill size="40" fill="#E53E3E" />
                  <Text as="h1" mt="4" color="red.500" fontSize={{ base: 'xl', lg: '3xl' }} fontWeight="bold" textAlign="center" lineHeight="28px">
                    Houve um erro ao realizar a confirmação, por favor tente novamente...
                  </Text>
                </>
              ) : (
                <>
                  <RiThumbUpFill size="40" fill="#D0D0D0" />
                  <Text as="h1" mt="4" color="#8FC74C" fontSize={{ base: 'xl', lg: '3xl' }} fontWeight="bold" textAlign="center" lineHeight="28px">
                    TRANSPORTADORA
                    <br />
                    ATUALIZADA COM SUCESSO!
                  </Text>
                </>
              )}
            </>
          )}
        </Center>
        <Image display={{ base: 'none', lg: 'block' }} src={caminhoesparalelos} />
      </VStack>
      <Flex h="100%" w={{ base: 'unset', lg: 'calc(100% - 720px)' }}>
        <Flex
          py="16"
          pl={{ base: '6', lg: '6' }}
          pr={{ base: '6', lg: '10' }}
          flexDir="column"
          overflow={{ base: 'unset', lg: 'auto' }}
          height={{ base: 'max-content', lg: '100%' }}
          scrollbar-gutter="stable"
          w="100%"
          justify="center"
        >
          {/* <Center>
            <VStack p="3" borderTop="8px solid #4d72ad" boxShadow="0px 5px 10px 0px #00000026;" w="100%" borderBottomRadius="5px" width="max-content" min-width="415px">
              <Stack direction={{ base: 'column', lg: 'row' }} w="100%">
                {logoPreview ? <Image src={logoPreview} alt="logo transportadora" h="134px" maxW="300px" /> : <Image src={logoPlaceholder} />}
                <VStack w="100%" gap="5px" spacing="0" align="flex-start">
                  <Text fontSize="sm" color="#9b9b9b">
                    {getValues('transportador.nomeFantasia')}
                  </Text>
                  <HStack>
                    <MdEmail fill="#5c5c5c" />
                    <Text fontSize="sm" color="#9b9b9b">
                      {getValues('contato.email')}
                    </Text>
                  </HStack>
                  <Stack direction={{ base: 'column', lg: 'row' }}>
                    <HStack>
                      <RiWhatsappFill fill="#5c5c5c" />
                      <Text fontSize="sm" color="#9b9b9b" whiteSpace="nowrap">
                        {getValues('contato.celular')}
                      </Text>
                    </HStack>
                    {getValues('transportador.telefone') && (
                      <HStack>
                        <MdPhone fill="#5c5c5c" />
                        <Text fontSize="sm" color="#9b9b9b" whiteSpace="nowrap">
                          {getValues('transportador.telefone')}
                        </Text>
                      </HStack>
                    )}
                  </Stack>
                  {getValues('transportador.site') && (
                    <HStack>
                      <MdWeb fill="#5c5c5c" />
                      <Text fontSize="sm" color="#9b9b9b">
                        {getValues('transportador.site')}
                      </Text>
                    </HStack>
                  )}
                </VStack>
              </Stack>
              {getValues('observacoesGerais') && (
                <Box border="1px solid #e6e6e6" p="2" w="100%">
                  <Text dangerouslySetInnerHTML={{ __html: getValues('observacoesGerais').replace('\n', '<br />') }} fontSize="sm" color="#9b9b9b" />
                </Box>
              )}
            </VStack>
          </Center> */}
          <Text mt="12" fontSize="lg">
            A partir de agora, sua transportadora aparecerá como sugestão nas cotações de frete dos embarcadores que usam o Active OnSupply. Quando for selecionado, o cliente entrará em contato
            diretamente com você.
          </Text>
          <br />
          <Text fontWeight="bold" fontSize="lg">
            Obrigado e bons negócios!
          </Text>
          <Box mt="5">
            <Box bg="#182128" p="5">
              <VStack>
                <Text color="white" fontSize="2xl" lineHeight="1.2" fontWeight="bold">
                  PORTAL DO TRANSPORTADOR
                </Text>
                <Text color="#a3abae" fontSize="xs">
                  Assista os vídeos e surpreenda seu embarcador
                </Text>
              </VStack>
            </Box>
            <Box bg="#8FC14E" px="5" py="3">
              <Text as="a" color="white" fontSize="xl" href="https://activecorp.com.br/ajuda/home-3/bem-vindo-ao-onsupply/transportador/">
                Clique aqui e saiba mais!
              </Text>
            </Box>
          </Box>
        </Flex>
      </Flex>
    </Stack>
  );
}

export { AtualizaCadastroOnsupply };
